import { RtResponse } from "../RtResponse";
import { AbstractRow } from "../RtTypes";

export const makeEmptyResponse = <
  TRow extends AbstractRow,
>(): RtResponse<TRow> => ({
  rows: [],
  totalRows: 0,
});
